<template>
  <div class="simmerring-selector__container">
    <div class="simmerring-selector__container__cards">
      <div
        class="card"
      >
        <div class="card-content">
          <h2 class="h4">
            {{ $tv("finderTitle", "simmerringSelector") }}
          </h2>
          <div class="card-content__container">
            <div class="card-content__description">
              {{ $tv("finderDescription", "simmerringSelector") }}
            </div>
            <div class="finder-image">
              <SimmerringFinder class="finder-icon" />
            </div>
          </div>
          <div class="card-content__button">
            <Button
              :theme-color="'base'"
              @click="goToGuidedFinder"
            >
              <span> {{ $tv('openFinder', 'simmerringSelector') }}</span>
            </Button>
          </div>
        </div>
      </div>
      <div
        class="card"
      >
        <div class="card-content">
          <h2 class="h4">
            {{ $tv("assistantTitle", "simmerringSelector") }}
          </h2>
          <div class="card-content__container">
            <div class="card-content__description">
              {{ $tv("assistantDescription", "simmerringSelector") }}
            </div>
            <div class="assistant-image">
              <div class="finder-image">
                <img loading="lazy"
                  :src="isWidget
                    ? ($i18n.locale === 'de' ? assistantImgDe : assistantImgEn)
                    : BASE_URL + `/img/simmerring_assistant_${$i18n.locale === 'de' ? 'deutsch' : 'english'}.png`"
                  alt="Simmerring Assistant"
                  referrerpolicy="no-referrer"
                >
              </div>
            </div>
          </div>
          <div class="card-content__button">
            <Button
              :theme-color="'base'"
              @click="goToAssistant"
            >
              <span>{{ $tv('openAssistantPage', 'simmerringSelector') }}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SimmerringFinder from '~/assets/images/simmerring_finder.svg?component'
import {Button} from '@progress/kendo-vue-buttons'
import {IS_WIDGET, WIDGET_CONFIG} from '~/widgets/shared/widget-config'
import assistantImgEn from '~/public/img/simmerring_assistant_english.png'
import assistantImgDe from '~/public/img/simmerring_assistant_deutsch.png'

const isWidget = inject(IS_WIDGET, false)
const widgetConfig = isWidget ? inject(WIDGET_CONFIG) : null

const emit = defineEmits(['go-to-finder', 'go-to-assistant'])

const app = isWidget ? null : (typeof useNuxtApp !== 'undefined' ? useNuxtApp() : null)
const BASE_URL = widgetConfig?.assetBaseUrl ?? useRuntimeConfig().public.BASE_URL

const goToGuidedFinder = () => {
  emit('go-to-finder')
  if (!isWidget) {
    navigateTo(app!.$globalization.localePath('/simmerring-selector/simmerring-finder'))
  }
}

const goToAssistant = () => {
  emit('go-to-assistant')
  if (!isWidget) {
    navigateTo(app!.$globalization.localePath('/simmerring-selector/simmerring-assistant'))
  }
}
</script>
<style lang="scss">
.simmerring-selector__container {
  width: 100%;
  margin-bottom: 2rem;

  &__cards {
    display: flex;
    width: 100%;

    .card {
      width: 50%;
      padding: 1rem;
      margin: 2rem .625rem 0;

      h2 {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: $base-text-font-weight-semi-bold;
        line-height: 1.5rem;
      }

      .card-content__container {
        display: flex;
        justify-content: space-between;

        .finder-image {
          .finder-icon {
            width: 11.5625rem;
            height: 11.5625rem;
          }
        }

        .assistant-image {
          .finder-image {
            img {
              width: 11.5625rem;
              height: 11.5625rem;
            }
          }
        }
      }

      .card-content__button {
        display: flex;
        justify-content: flex-end;
        padding-top: 1rem;
      }

      .card-content__description {
        padding-top: 1rem;
        line-height: 1.125rem;
        font-weight: $base-text-font-weight-light;
      }
    }

    .card:first-child {
      margin-left: 0;
    }

    .card:last-child {
      margin-right: 0;
    }

    @include breakpoint-down($md) {
      flex-direction: column;

      .card {
        width: calc(100% - 2rem);
        padding: 1rem;
        margin: 2rem 0 1rem;
        box-shadow: $shadow-default;
      }

      .card:first-child {
        margin-bottom: 0;
      }

    }
  }
}
</style>
